"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionModelFieldImage = exports.ModelMutatorImage = void 0;
const core_api_1 = require("@ikegps/core-api");
const collection_field_1 = require("../collection.field");
class ModelMutatorImage extends collection_field_1.ModelMutator {
    add(captureId) {
        const stateValue = this.field.stateValue || [];
        // Don't add existing captures twice.
        const index = stateValue.indexOf(captureId);
        if (index > -1) {
            return;
        }
        this.state.setFieldValue(this.field.id, [...stateValue, captureId]);
    }
    copy(from) {
        for (const capture of from.getCaptures()) {
            this.add(capture.objectId);
        }
        return true;
    }
}
exports.ModelMutatorImage = ModelMutatorImage;
class CollectionModelFieldImage extends collection_field_1.CollectionModelField {
    static isImageField(f) {
        return f.schema.type === CollectionModelFieldImage.TYPE;
    }
    get Mutator() {
        if (this._Mutator == null) {
            this._Mutator = new ModelMutatorImage(this);
        }
        return this._Mutator;
    }
    get value() {
        return this.getCaptures();
    }
    getOwnedCaptureIds() {
        return this.getCaptureIds();
    }
    getCaptureIds() {
        const stateValue = this.stateValue;
        if (stateValue == null) {
            return [];
        }
        return stateValue;
    }
    getOwnedCaptures() {
        return this.getCaptures();
    }
    getCaptures() {
        return this.getCaptureIds().map(c => this.collection.state.getCapture(c)).filter(c => !!c);
    }
    hasValue() {
        return this.value.length > 0;
    }
}
exports.CollectionModelFieldImage = CollectionModelFieldImage;
CollectionModelFieldImage.TYPE = core_api_1.IkeFieldType.IMAGE;
//# sourceMappingURL=image.field.js.map